<template>
  <v-container fluid>
    <v-layout row wrap justify-space-between align-content-space-between>
      <v-flex xs12 lg2 class="mx-3">
        <h1 class="blue-grey--text headline">Measurements:</h1>
        <v-text-field
          readonly
          box
          title="Fit Type"
          label="Fit Type:"
          class="measurements-input"
          v-model="order.measurements.fit"
        ></v-text-field>
        <v-text-field
          readonly
          v-for="item in order.measurements.data"
          :key="item.id"
          box
          :title="item.title"
          :label="item.label+':'"
          class="measurements-input"
          type="number"
          :id="item.label"
          :name="item.label"
          v-model="item.measurementvalue"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 lg2 class="mx-3">
        <h1 class="blue-grey--text headline">Materials:</h1>
        <v-text-field
          box
          readonly
          v-for="item in order.materials"
          :key="item.id"
          :label="item.label"
          class="materials-input"
          type="text"
          v-model="item.measurementvalue"
        ></v-text-field>
      </v-flex>
      <!-- <v-spacer></v-spacer> -->
      <v-flex xs12 sm6 md6 order-md1>
        <v-layout row wrap fill-height>
          <!-- <v-flex class="mt-5" xs12 sm6>
            <div v-html="order.suits.front"></div>
          </v-flex>
          <v-flex class="mt-5" xs12 sm6>
            <div v-html="order.suits.back"></div>
          </v-flex>  -->
          <suitsDisplay :front="order.suits.front" :back="order.suits.back" />
          <v-flex v-if="order.addons && order.addons.length>0" xs12 class="mt-5 pa-5 pb-0">
            <v-layout class="mt-5" row wrap>

              <v-flex xs10 sm6 md4 lg3 v-for="item in order.addons" :key="item.id">
                <v-select
                  v-if="item.type=='select'"
                  box
                  :items="item.options"
                  readonly
                  item-text="label"
                  item-value="label"
                  :label="item.label"
                  class="materials-input"
                  type="text"
                  v-model="item.value"
                ></v-select>
                <v-checkbox
                  readonly
                  v-else-if="item.type=='checkbox'"
                  v-model="item.value"
                  :label="item.label"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="order.colorlist && admin" xs12 class="pa-5 pb-0">
            <v-layout row wrap justify-space-between>
              <v-flex class="mx-1" xs5 md3 xl2 v-for="item in order.colorlist" :key="item.sections[0]">
                <b>{{item.name}}:</b> {{item.value}}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="pa-5 pb-0">
            <v-textarea readonly v-model="order.note" box label="Note"></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import suitsDisplay from "@/components/suitsDisplay";
export default {
    props:['order',"admin"],
    components:{
        suitsDisplay
    }
};
</script>

<style>
</style>
